import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import {TextField, Card, CardContent, Typography, Grid, Button, Box, Tooltip,Dialog, DialogTitle, DialogContent,DialogActions,IconButton } from '@mui/material';
import { Table, Sheet, } from '@mui/joy';
import useMediaQuery from '@mui/material/useMediaQuery';
import ChatButton from "../../assets/images/chatforbutton.png";
import EmailButton from "../../assets/images/Emailforbutton.png";
import Slider from '@mui/material/Slider';
import { useDispatch } from 'react-redux';
import config from '../../AppConfig';
import { fetchData, postData } from "../../redux/apiSlice";
import GaugeComponent from 'react-gauge-component';
import Moment from 'moment';
import { styled } from '@mui/material/styles';
import Chat from "../../Components/CreditSnapshot/Chat";
import Header from '../../views/Web/FundingShot/Header';
import Footer from '../../views/Web/FundingShot/Footer';
import step1 from '../../assets/images/step1.png';
import verification from '../../assets/images/verification.png';
import report from '../../assets/images/report.png';
import AuthUser from "../../Components/Auth/AuthUser";
import Freez from '../../Components/Loader/Loader';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form } from 'formik';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import swal from "sweetalert";
import * as Yup from 'yup';
import Stepper from "./Stepper";
import LogoutIcon from '@mui/icons-material/Logout';
const AnimatedButton = styled(Button)(({ theme }) => ({
    display: "contents",
    alignItems: "right",
    justifyContent: "right",
    overflow: "hidden",
    position: "relative",
    width: "48px",
    padding: theme.spacing(1),
    textTransform: "none", // Prevents uppercase transformation
    transition: theme.transitions.create("width", {
      duration: theme.transitions.duration.short,
    }),
    "&:hover": {
      variant:"contained",
      width: "150px", // Adjust this width for wrapping effect
    },
    "& .icon": {
      
      transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.short,
      }),
      marginRight: theme.spacing(1),
    },
    "& .text": {
      opacity: 0,
      whiteSpace: "nowrap",
      transform: "scaleX(0)", // Initially hidden
      transformOrigin: "left",
      transition: theme.transitions.create(["opacity", "transform"], {
        duration: theme.transitions.duration.short,
      }),
    },
    "&:hover .text": {
      opacity: 1,
      transform: "scaleX(1)", // Fully visible on hover
    },
  }));
let newDateStr = '';
function getAriaValueText(value) {
    return `${value}`;
}
let chatSessionId = null;



function ScoreReport() {
    const dispatch = useDispatch();
      const { http } = AuthUser();
      const { userId } = useParams();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [creditScore, setCreditScore] = useState(0);
    const [score, setScore] = useState('');
    const marks = [
        {
            value: 0,
            label: '$2,000',
        },
        {
            value: 20,
            label: score ? `$${new Intl.NumberFormat().format(score.minValue)}` : '$9,800',
        },
        {
            value: 47,
            label: score ? `$${new Intl.NumberFormat().format(score.maxValue)}` : '$18,800',
        },
        {
            value: 100,
            label: '$750,000',
        },
    ];
    const CustomSlider = styled(Slider)({
        color: '#9C9FA9', // blue for the filled track
        height: isMobile ? 5 :6,
        '& .MuiSlider-track': {
            backgroundColor: '#00A4CB',
            border: 'none',
        },
        '& .MuiSlider-rail': {
            backgroundColor: '#9C9FA9', // gray for the unfilled track
            opacity: 1,
        },
        '& .MuiSlider-thumb': {
            height:isMobile?18: 24,
            width:isMobile?18: 24,
            backgroundColor: '#fff', // dark blue thumb
            border: isMobile?'5px solid #034B94':'6px solid #034B94',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: '0 0 0 8px rgba(0, 63, 136, 0.16)',
            },
            '&::before': {
                display: 'none',
            },
        },
        '& .MuiSlider-markLabel': {
    
            color: '#000',
            fontWeight: 'normal',
        },
        '& .MuiSlider-markLabel[data-index="0"], & .MuiSlider-markLabel[data-index="3"]': {
            fontWeight: 'bold',
            fontSize:isMobile?"10px": '14px',
        },
        '& .MuiSlider-markLabel[data-index="1"], & .MuiSlider-markLabel[data-index="2"]': {
            color: '#197B1F',
            fontSize: isMobile?"8px":'14px',
        },
    });
    const getColorForPointer = (score) => {
        if (score >= 300 && score < 599) {
            return '#df240c'; // Red for Poor
        } else if (score >= 600 && score < 660) {
            return '#fe992b'; // Orange for Fair
        } else if (score >= 661 && score < 715) {
            return '#eff307'; // Yellow for Good
        } else if (score >= 716 && score < 747) {
            return '#c9ff38'; // Green for Very Good
        } else if (score >= 748 && score <= 850) {
            return '#01c201'; // Dark Green for Excellent
        } else {
            return '#000000'; // Default to black if score is invalid
        }
    };
    const getCreditScoreLabel = (score) => {
        if (score >= 300 && score < 599) {
            return 'Poor';
        } else if (score >= 600 && score < 660) {
            return 'Fair';
        } else if (score >= 661 && score < 715) {
            return 'Good';
        } else if (score >= 716 && score < 747) {
            return 'Very Good';
        } else if (score >= 748 && score <= 850) {
            return 'Excellent';
        } else {
            return 'Invalid Score';
        }
    };
    const navigate = useNavigate();
    const formattedDate = (score ? Moment(score.reportDate).format('MM/DD/YYYY') : '');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const [chatEnable, setChatEnable] = React.useState(false);
    const [aid, setAID] = useState(localStorage.getItem("SnapShot_aid"));
    const [emailEnable, setEmailEnable] = useState(false);
    const [companyObj, setCompanyObj] = React.useState(false);
    const [isChatOpen, setIsChatOpen] = useState(false);
    const chatbotRef = useRef(null);
    const [isMinimized, setIsMinimized] = useState(true);
    const [startJourneyOpen, setStartJourneyOpen] = useState(false);
    const [assistYouFlag, setAssistYouFlag] = useState(false);
    const [emailChatopen, setEmailChatopen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [creditSnapshotObj, setCreditSnapshotObj] = useState([]);
    const [Fname, setFname] = useState('');
    const [memberEmail, setMemberEmail] = useState('');
    const [companyId, setCompanyId] = useState();
    const [crsSignupEnabled, setCrsSignupEnabled] = useState(false)
    const [BlackboxObj, setBlackboxObj] = useState(null);
    const [openIframe, setOpenIframe] = useState(false);
    const [freez, setFreez] = React.useState(false);
    const [mobile,setMobile]=useState();
    const [chatEmail, setChatEmail] = useState(localStorage.getItem('chatbot_email') != undefined ?  localStorage.getItem('chatbot_email') : null);
    const [chatfirstName, setFirstName] = useState(localStorage.getItem('SnapShot_firstName') != undefined ?  localStorage.getItem('SnapShot_firstName') : null);
    
    const handleFreezStop = () => {
        setFreez(false);
      };
      const handleFreezStart = () => {
        setFreez(true);
      };

    const funtingNavigate = () => {
        navigate('/fundingShotstep2');
    }
    const handleIFrame = () => {
    setOpenIframe(true);
    }

    const handleOpenCalendar = () => {
        const updatedUrl = creditSnapshotObj.funding_shot.meeting_link;
        window.open(updatedUrl, '_blank');
    }
    
    const handleCloseDialog = () => {
    setOpenIframe(false);
    }
    const openChatPopup = (e) => {
        setIsChatOpen(true);
        var sessionMessagesObj;
        if (localStorage.getItem("sessionMessages") != undefined) {
            sessionMessagesObj = localStorage.getItem("sessionMessages");
        }
        e.preventDefault();
        const element = document.getElementById("chatbotDiv");
        element.style.display = "block";
        setIsMinimized(!isMinimized);

        setStartJourneyOpen(false);
        chatSessionId = localStorage.getItem('chatSessionId');
        if (chatSessionId != null) {
            const sessionMessage1 = localStorage.getItem("sessionMessages");
            if (sessionMessage1) {
                const parsedMessages = JSON.parse(sessionMessage1);
                setMessages(parsedMessages);
            }

            setAssistYouFlag(true);
        } else {
            // const Fname = localStorage.getItem('Main_firstName')?.trim() ? localStorage.getItem('Main_firstName') : 'Friend';
            if (sessionMessagesObj > 1) {
                setMessages(sessionMessagesObj);
            }
            if (!assistYouFlag) {
                setAssistYouFlag(true);
            }
        }

    }
    const changeOpenChatPopupValue = (value) => {
        setIsMinimized(value);
    }

    const openEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setIsMinimized(true);
        setEmailChatopen(true);
    }

    const closeStartJourneyOpen = () => {
        setStartJourneyOpen(false);
    }

    const closeEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setEmailChatopen(false);
    }
   

    const getScoreData = async () => {
        handleFreezStart();
        const apiUrl = '/creditSnapshotInternalLogin/' + userId;
        const res = await dispatch(fetchData(apiUrl)).unwrap();
        if (res) {
          if (res.success === true) {
            setAID(res.data.aid);
            setScore(res.data);
            setMemberEmail(res.data.userObj.email);
            setFname(res.data.userObj.first_name);
            // setlogourl(res.data ? config.BACKEND_URL + "images/companyLogo/" + res.data.affCobrandingLogo : '')
            // setCompanyName(res.data ? res.data.companyName : '')
            setCreditScore(res.data.creditScore)
            localStorage.setItem("creditSnapshotLink", res.data.creditSnapshotLink);        
    
            var email1 = localStorage.getItem("chatbot_email");
            console.log("email1:" +email1);
            if(email1 != undefined && (email1 != res.data.userObj.email)) {
                localStorage.removeItem("chatbot_email");
                localStorage.removeItem("sessionMessages");
                localStorage.removeItem("chatSessionId");
            }
    
            handleFreezStop();
            setTimeout(function () {
              handleFreezStop();
            }, 8000);
          } else {
            navigate(-1);
          }
        }
    }
    
    const getAffiliateCSSInfo = async () => {
    const apiUrl = '/getCSSInfo/' + userId;
    const res = await dispatch(fetchData(apiUrl)).unwrap();
    if (res) {
        if (res.success === true) {
        // setCreditSnapshotObj(res.data);
        // setCrsSignupEnabled(res.data.crs_signup_enabled);
        setCompanyId(res.data.company_master_id);
        } else {
        navigate(-1);
        }
    }
    }

    useEffect(() => {
        getScoreData();
        getAffiliateCSSInfo();
        if (score) {
        const dateStr = score ? score.reportDate : '';
        const date = new Date(dateStr);
        date.setDate(date.getDate() + score.offerDetails[0].days);
        newDateStr = date.toISOString().slice(0, 10);
        }
    }, [])

     const Upgradeto3B = () => {
        setStartJourneyOpen(false);
        handleFreezStart();
        var BlackboxObj1 = null;
        if (window.IGLOO && typeof window.IGLOO.getBlackbox === 'function') {
            BlackboxObj1 = window.IGLOO.getBlackbox();
            setBlackboxObj(BlackboxObj1);
            console.log('Blackbox generated:', BlackboxObj1);
        } else {
            console.error('IGLOO or getBlackbox function is not available.');
        }
    
        localStorage.setItem('aid', score ? score.aid : 'seo');
        localStorage.setItem('pid', score ? score.pid : '00017');
        localStorage.setItem('Main_password', score ? score.userObj ? atob(score.userObj.password) : '' :'');
        http.post("/registerEnrollment", {
          ugradeToCD: true,
          userId: userId,
          blackboxCode: BlackboxObj1 ? BlackboxObj1.blackbox : "",
          step: 1
        })
          .then((res) => {
            handleFreezStop();
            if (res.data.success === true) {
              localStorage.setItem("trackingToken", res.data.data.trackingToken);
              localStorage.setItem('customerToken', res.data.data.customerToken);
              localStorage.setItem('Step', res.data.data.nextstep);
              localStorage.setItem('idQuestions', JSON.stringify(res.data.data.idQuestions));
            //   localStorage.setItem("UpgradeTo3B", true);
              localStorage.setItem('Main_firstName', score ? score.userObj.first_name : '');
              localStorage.setItem('Main_lastName', score ? score.userObj.last_name : '');
              localStorage.setItem('Main_email', score ? score.email : '');
              window.location.href = config.BASE_URL + `enroll?pid=` + localStorage.getItem('pid') + `&aid=` + localStorage.getItem('aid') + `&sid=&tid=&adid=&from=crsleads`;
            } else {
              handleFreezStop();
              const errorObj = res.data.data.errorByCD;
              swal({
                title: "Failed",
                text: errorObj[0] && errorObj[0].message ? errorObj[0].message : res.data.data.errorByCD,
                icon: "error",
                button: "Ok",
              })
            }
          })
    }

    const getCreditSnapshotDetails = (value) => {
        setCompanyObj(value);
        const phoneList = JSON.parse(value.snapshot_phone_no || '[]');
            if (phoneList.length > 0) {
            setMobile(phoneList[0].number);
        }
        console.log(value);
        setChatEnable(value.funding_shot.enable_chat_support == 1 ? true : false);
        setEmailEnable(value.funding_shot.enable_email_support == 1 ? true : false);
        localStorage.setItem('SnapShot_chat_support', value.funding_shot.enable_chat_support == 1 ? true : false);
        localStorage.setItem('SnapShot_email_support', value.funding_shot.enable_email_support == 1 ? true : false);
        setCreditSnapshotObj(value);
    }

    const sendEmailChatSchema = Yup.object().shape({
        subject: Yup.string()
            .min(2, 'Too Short!')
            .required('Please enter subject'),
        description : Yup.string()
            .min(2, 'Too Short!')
            .required('Please enter Description'),
        email: Yup.string()
        //   .email('Please enter a valid email address') 
        .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
            .required('Please enter your email address'),
    });

    const handleLogout = () => {
        const baseUrl = window.location.origin;
        localStorage.removeItem("chatbot_email");
        localStorage.removeItem("sessionMessages");
        localStorage.removeItem("chatSessionId");
        const updatedUrl = config.BASE_URL + `fundingSnapshotlogin`;
        window.location.href = updatedUrl;
    }
    return (
        <>
         <Header aid={aid} logoName={'creditSnapShot'} onValueChange={getCreditSnapshotDetails}/>
         <Grid container item lg={12} md={12} xs={12} sm={12} sx={{display:"flex",justifyContent:"end"}} p={2}>
                   <Grid item lg={6} md={6} xs={6} sm={6}>
                       {/* <Button variant="contained">Back</Button> */}
                   </Grid>
                   <Grid item lg={6} md={6} xs={6} sm={6} sx={{display:"flex",justifyContent:"end"}}>
                       <AnimatedButton
                         variant="outlined"
                         color="primary"
                         onClick={handleLogout}
                         sx={{
                           minWidth: 50, // Initial width for just the icon
                           maxWidth: 150, // Full width when the text is visible
                           height: 40, // Fixed height for consistent alignment
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center",
                           gap: "8px",
                           textTransform: "none",
                           overflow: "hidden", // Ensures only visible content is displayed
                           transition: "all 0.3s", // Smooth transition for width
                           whiteSpace: "nowrap", // Prevents text wrapping
                           "&:hover": {
                             backgroundColor: "blue", // Solid blue background on hover
                             color: "white", // Optional: Change text/icon color for better contrast
                             minWidth: 150, // Expand width to show text
                           },
                           "& svg": {
                             transition: "transform 0.3s",
                           },
                           "& span": {
                             opacity: 0,
                             transition: "opacity 0.3s",
                             display: "inline-block",
                             fontSize:"17px"  
                           },
                           "&:hover span": {
                             opacity: 1, // Show text on hover
                           },
                           "&:hover svg": {
                             transform: "translateX(-10px)",
                             position: "relative",  // Shift icon slightly left to align with text
                           },
                         }}
                       >
                         <span>Log Out </span>&nbsp;
                         <LogoutIcon sx={{position: "absolute"}}
                         />
                       </AnimatedButton>
                   </Grid>
               </Grid>
         <Stepper value={3} />
            <Box sx={{paddingLeft:isMobile?"0px":"50px",paddingRight:isMobile?"0px":"50px"}}>
                <Card variant="outlined" sx={{boxShadow:"none",border:"1px solid #2E67BC",borderRadius:"20px",padding:isMobile?"1%":"2%"}}>
                    <CardContent>
                        <Grid container item lg={12} md={12} sm={12} xs={12}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }}>
                                    <img alt="#" src={require("../../assets/images/equifax.png")} style={{ marginLeft: "auto", marginRight: "auto", height: "100%" }} />
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }} mt={2} mb={1}>
                                    <Typography variant={isMobile?"h6":"h4"} fontWeight={700}>Your Credit Report Summary</Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}  alignItems="stretch">
                                    <Grid item lg={7} md={7} sm={12} xs={12}  sx={{ display: 'flex', flexDirection:isMobile?"row": 'column' }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }}>
                                            <Card sx={{ border: "1px solid #ACA3A3", borderRadius: "20px", width: "100%", boxShadow: "none" }}>
                                                {/* <CardContent> */}
                                                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center",mt:3 }}>
                                                    <GaugeComponent
                                                        value={creditScore}
                                                        type="radial"
                                                        minValue={300}
                                                        maxValue={850}
                                                        labels={{
                                                            valueLabel: {
                                                                fontSize: 80,
                                                                formatTextValue: (value) => `${value} :  ${getCreditScoreLabel(value)}`,
                                                                style: {
                                                                    fill: "#000000",
                                                                    // backgroundColor: getColorForPointer(creditScore),
                                                                    fontSize: "50px",
                                                                    textShadow: "0px 0px",
                                                                    fontWeight: "bold"
                                                                }
                                                            },
                                                            tickLabels: {
                                                                type: "outer",
                                                                ticks: [
                                                                    { value: 300 },
                                                                    { value: 362 },
                                                                    { value: 424 },
                                                                    { value: 484 },
                                                                    { value: 548 },
                                                                    { value: 610 },
                                                                    { value: 672 },
                                                                    { value: 734 },
                                                                    { value: 796 },
                                                                    { value: 850 }
                                                                ],

                                                            }
                                                        }}
                                                        arc={{
                                                            colorArray: ["#df240c", "#df240c", "#df240c", "#df240c", "#df240c", "#fe992b", "#eff307", "#c9ff38", "#01c201"],
                                                            subArcs: [
                                                                { limit: 300, color: '#df240c', showTick: true },
                                                                { limit: 362, color: '#df240c', showTick: true },
                                                                { limit: 424, color: '#df240c', showTick: true },
                                                                { limit: 484, color: '#df240c', showTick: true },
                                                                { limit: 548, color: '#df240c', showTick: true },
                                                                { limit: 610, color: '#fe992b', showTick: true },
                                                                { limit: 672, color: '#eff307', showTick: true },
                                                                { limit: 734, color: '#c9ff38', showTick: true },
                                                                { limit: 796, color: '#01c201', showTick: true },

                                                            ],
                                                            padding: 0,
                                                            cornerRadius: 1,
                                                            width: 0.3,
                                                            valueConfig: {
                                                                formatTextValue: (value) => `${value} :  ${getCreditScoreLabel(value)}`,
                                                                style: {
                                                                    fill: getColorForPointer(creditScore),
                                                                    fontSize: "50px",
                                                                    textShadow: "0px 0px",
                                                                    fontWeight: "bold"
                                                                } // Corrected formatTextValue usage
                                                            }
                                                        }}
                                                        pointer={{
                                                            elastic: true,
                                                            animationDelay: 0,

                                                        }}

                                                    />
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} p={1} sx={{display:"flex",justifyContent:"center"}}  mt={1}>
                                                    <Grid item>
                                                        <Typography variant="body1"><b>Vantage Score 3.0</b>&nbsp;
                                                            <Tooltip title="Vantage 3.0 uses the same 300-850 range as base FICO.">
                                                                <span><img alt="#" src={require("../../assets/images/info-icon.png")} /></span>
                                                            </Tooltip>
                                                        </Typography>
                                                    </Grid>
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    <Grid item >
                                                        <Typography variant="body1">
                                                            As of {formattedDate}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }} mt={1} mb={2}>
                                                        <Typography variant={isMobile?"h6":"h5"}><b>Total Negative Items </b> <span style={{ fontSize: "1.2em",color: score?.totalNeagtiveItems === 0 ? "green" : "red", }}><b>{score ? score.totalNeagtiveItems : ''}</b> </span>
                                                            <Tooltip title="These categories are the reasons for why your score is not higher.">
                                                                <span><img alt="#" src={require("../../assets/images/info-icon.png")} /></span></Tooltip></Typography>
                                                    </Grid>
                                               
                                                {/* </CardContent> */}
                                            </Card>
                                        </Grid>
                                    </Grid>
                                    <Grid item lg={5} md={5} sm={12} xs={12} sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }}>
                                            <Card sx={{ border: "1px solid #ACA3A3", borderRadius: "20px", width: "100%", padding: "3%", boxShadow: "none" }}>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} mb={1}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Open Accounts</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.openAccounts : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} mb={1}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Total Credit</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{`$${new Intl.NumberFormat().format(score ? score.totalCredit : '0')}`}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12} mb={1}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={8} md={8} sm={6} xs={6}>Credit Utilization</Grid>
                                                            <Grid item lg={4} md={4} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.utilization : '0'}%</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Inquiries</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.inquiries : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                               
                                                {/* <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Bankruptcy</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.bankruptcies : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid> */}

                                            </Card>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} p={1}>
                                            <Typography fontWeight={"bold"}>Negative Items</Typography>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ justifyContent: "center" }}>
                                            <Card sx={{ border: "1px solid #ACA3A3", borderRadius: "20px", width: "100%", padding: "3%", boxShadow: "none" }}>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Late Payments</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.latePayments : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Charge Offs</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.chargeOffs : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Collections</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.collections : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                               
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Card className='scroringCard'>
                                                        <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between", }}>
                                                            <Grid item lg={6} md={6} sm={6} xs={6}>Public Records</Grid>
                                                            <Grid item lg={6} md={6} sm={6} xs={6} sx={{ textAlign: "right" }}><b>{score ? score.publicRecord : '0'}</b></Grid>
                                                        </Grid>
                                                    </Card>
                                                </Grid>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            {score?.eligible ? (
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                {/* <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={isMobile?3:2}>
                                   <img alt="#" src={require("../../assets/images/congratsIcon.png")} style={{ width: isMobile?'40px':"50px", position: "relative", }} />
                                </Grid> */}
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={isMobile?2:0}>
                                    <Typography variant={isMobile?'h5':'h4'} color="#3FAC19" sx={{ display: "flex", alignItems: "center", gap: 1,fontWeight:isMobile?'bold':"800",fontStyle: "normal" }}> 
                                        {/* <span> <img alt="#" src={require("../../assets/images/fireworks.png")} style={{ width: isMobile?'25px':"40px", position: "relative", }} /></span> */}
                                        Congratulations!
                                        {/* <span> <img alt="#" src={require("../../assets/images/fireworksRight.png")} style={{ width:isMobile?'25px': "40px", position: "relative",}} /></span>​ */}
                                        </Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={isMobile?0:2} mb={isMobile?1:2}>
                                    <Box sx={{ width:isMobile?250: 450 }}>
                                        <CustomSlider
                                            getAriaLabel={() => 'Temperature range'}
                                            getAriaValueText={getAriaValueText}
                                            defaultValue={[20, 47]}
                                            valueLabelDisplay="auto"
                                            marks={marks}
                                            disabled
                                        />
                                    </Box>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                    <Typography fontWeight="bold">You Have A Potential To Get</Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={1}>
                                    <Typography variant={isMobile?'h6':'h4'} color="#2E67BC" fontWeight="bold">{`$${new Intl.NumberFormat().format(score ? score.minValue : 1000)} - $${new Intl.NumberFormat().format(score ? score.maxValue : 100000)}`}</Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={1}>
                                    <Typography fontWeight="bold" textAlign="center">In Business Funding Based On Your 1 Bureau Equifax Score</Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mb={1}>
                                        <Button>
                                            {
                                                creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.enable_meeting_link ? 
                                                <Button
                                                onClick={handleOpenCalendar}
                                                variant="contained"
                                                size="lg"
                                                color="success"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#3FAC19", // Prevents uppercase transformation
                                                    minWidth: isMobile?'300px':'400px', 
                                                    maxWidth:isMobile?'350px': '450px',
                                                    alignItems: "center",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderRadius:"8px",
                                                    fontSize:isMobile?'15px':"20px"
                                                }}>BOOK A MEETING
                                            </Button>
                                            : ''
                                            }
                                        </Button>
                                </Grid>
                                {/* <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={3}>
                                    <Typography textAlign="center" fontWeight={500}>Your Scores Can Vary By Bureau </Typography>
                                </Grid> */}
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                    <Typography textAlign="center" fontWeight="bold">Get a 3 Bureau Credit Report & Scores To Enable Us To Get a </Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                    <Typography textAlign="center" fontWeight="bold">Total Picture Of Your Credit And Funding Eligibility. </Typography>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={3}>
                                    <Button variant='contained' color='primary' onClick={() => { Upgradeto3B() }} sx={{
                                        backgroundColor: "#2E67BC",
                                        minWidth: isMobile?'100%':'350px', 
                                        maxWidth:isMobile?'350px': '450px',
                                        // minHeight: "50px",
                                        fontSize: isMobile?'13px':"16px",
                                        borderRadius: "10px",
                                        fontWeight:700,
                                        padding:"12px 16px",
                                        // animation: "blink 1.5s infinite",
                                        // "@keyframes blink": {
                                        //     "0%": { backgroundColor: "#3FAC19" },
                                        //     "50%": { backgroundColor: "#55cc28" },
                                        //     "100%": { backgroundColor: "#3FAC19" },
                                        // },
                                    }}>Upgrade to Get your 3-Bureau Report Now​</Button>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={3}>
                                    <Typography textAlign="cener"><b>Questions? </b>Contact {creditSnapshotObj ? creditSnapshotObj.company ? creditSnapshotObj.company.company_name : '' : ''} at <b>{mobile}</b> Now!</Typography>
                                </Grid>
                            </Grid>
                            ) : (
                                <Grid item lg={6} md={6} sm={12} xs={12} >
                                     <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography variant={isMobile?'h6':'h5'} fontWeight={"bolder"} color="#EA7A2E" mt={isMobile?3:0} mb={isMobile?0:1} sx={{ fontStyle: "normal",textAlign:"center"}}>A Funding Estimate Can't Be Calculated At This Time</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mb={1}>
                                        <Typography variant={isMobile?'h6':'h5'} fontWeight={isMobile?"bold":"bolder"} color="black" sx={{ fontStyle: "normal",textAlign:"center"}}>DON'T WORRY, WE CAN STILL HELP</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mb={1}>
                                        <Button>
                                            {
                                                creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.enable_meeting_link ? 
                                                <Button
                                                onClick={handleOpenCalendar}
                                                variant="contained"
                                                size="lg"
                                                color="success"
                                                sx={{
                                                    textTransform: "none",
                                                    backgroundColor: "#3FAC19", // Prevents uppercase transformation
                                                    minWidth: isMobile?'300px':'400px', 
                                                    maxWidth:isMobile?'350px': '450px',
                                                    alignItems: "center",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    borderRadius:"8px",
                                                    fontSize:isMobile?'15px':"20px"
                                                }}>BOOK A MEETING
                                            </Button>
                                            : ''
                                            }
                                        </Button>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                                        <img alt="information page"  style={{ width:isMobile?"100%":"50%", height: "auto", objectFit: "cover",margin:"auto" }} src={require("../../assets/images/InformationPage.png")} />
                                    </Grid>
                                    {/* <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography fontWeight={500} textAlign="center">Your Scores Can Vary By Bureau </Typography>
                                    </Grid> */}
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={1}>
                                        <Typography fontWeight="bold" textAlign="center">Get a 3 Bureau Credit Report & Scores To Get a</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                        <Typography fontWeight="bold" textAlign="center">Total Picture Of Your Credit And Funding Eligibility.</Typography>
                                    </Grid>
                                    <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mt={2}>
                                        <Button variant='contained' color='primary'   onClick={() => { Upgradeto3B() }} sx={{
                                        backgroundColor: "#2E67BC",
                                        minWidth: isMobile ? "100%" : "300px",
                                        minHeight: "50px",
                                        fontSize: isMobile?'13px':"16px",
                                        borderRadius: "10px",
                                        fontWeight:700,
                                        // animation: "blink 1.5s infinite",
                                        // "@keyframes blink": {
                                        //     "0%": { backgroundColor: "#3FAC19" },
                                        //     "50%": { backgroundColor: "#55cc28" },
                                        //     "100%": { backgroundColor: "#3FAC19" },
                                        // },
                                    }}>Upgrade to Get your 3-Bureau Report Now​</Button>
                                    </Grid>
                                </Grid> 
                                )}
                        </Grid>
                    </CardContent>
                </Card>
                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",

                    mb: isMobile ? 2 : 3,
                    padding: 2
                }}>
                    <Grid item>
                        <Typography fontWeight="bold" variant="h6">We Are Here To Help You Reach Your Goal.</Typography>
                    </Grid>
                    {
                      chatEnable ? (
                    <Grid item>
                        <Button varient="outlined"
                            onClick={openChatPopup}
                            // disabled={isChatOpen}
                            startIcon={<img src={require("../../assets/images/chatforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none !important",
                                border: "1px solid #2E67BC",
                                minWidth: '250px', maxWidth: '300px',
                                color: "black",
                                alignItems: "center",
                                borderRadius: "6px",
                                fontWeight: "bold"// Prevents uppercase transformation
                            }}>Chat With Us Now</Button>
                    </Grid>
                    ) : ''
                }
                    { emailEnable ? 
                    <Grid item >
                        <Button startIcon={<img src={require("../../assets/images/Emailforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            onClick={openEmailChatPopup}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC",
                                minWidth: '250px', maxWidth: '300px',
                                color: "black",
                                alignItems: "center",
                                borderRadius: "6px",
                                fontWeight: "bold" // Prevents uppercase transformation
                            }}>Email Us Now</Button>
                    </Grid>
                    : ''}
                    {
                       creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.step3_link ? 
                    <Grid item >
                        <Button
                            onClick={handleIFrame}
                            startIcon={<img src={require("../../assets/images/youtubeSnap.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC", // Prevents uppercase transformation
                                minWidth: '250px', maxWidth: '300px',
                                alignItems: "center",
                                color: "black",
                                borderRadius: "6px",
                                fontWeight: "bold"
                            }}>Watch Video
                        </Button>
                    </Grid>
                    : ''
                }
                    {/* <Grid item >
                        {
                            creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.enable_meeting_link ? 
                            <Button
                            onClick={handleOpenCalendar}
                            startIcon={<img src={require("../../../src/assets/images/meeting.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC", // Prevents uppercase transformation
                                minWidth: '250px', maxWidth: '300px',
                                alignItems: "center",
                                color: "black",
                                fontWeight: "bold",
                                borderRadius:"6px",
                            }}>Book A Meeting
                        </Button>
                        : ''
                        }
                        
                    </Grid> */}

                </Grid>
                <Box>
                    <Chat mEmail={memberEmail} firstName={Fname} isMinimized={isMinimized} changeOpenChatPopupValue={changeOpenChatPopupValue} openEmailChatPopup={openEmailChatPopup} companyId={companyObj.company_master_id} source="snapshot" />

                </Box>
            </Box>
            <Footer/>
            {isChatOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "2%",
                        right: "2%",
                        cursor: "pointer",
                    }}
                    onClick={openChatPopup}
                >
                    <img
                        src={require("../../assets/images/chatforbutton.png")}
                        alt="Chat Icon"
                        style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        boxShadow:
                            "0px 4px 8px rgba(0, 0, 0, 0.2), 0px 8px 16px rgba(0, 0, 0, 0.19)",
                        }}
                    />
                </Box>
            )}
            <Formik
            initialValues={{
            subject: '',
            description : '',
            email : ''
            }}
            validationSchema={sendEmailChatSchema}
            onSubmit={async (values, { resetForm }) => {
            handleFreezStart();
            http.post("/sendChatEmail", {
                email : values.email,
                subject : values.subject,
                description : values.description,
                companyId : companyObj.company_master_id,
                source : "snapshot"
            })
            .then((res) => {
                if (res.data.success === true) {
                swal({
                    title: "Success",
                    text: res.data.message,
                    icon: "success",
                    button: "Ok",
                });
                handleFreezStop();
                }else{
                // alert("something went wrong");
                handleFreezStop();
                }
            })
            closeEmailChatPopup();
            resetForm();
            }}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <Dialog
                open={emailChatopen}
                onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    // setDeleteOpen(false)
                }
                }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {/* Delete Pid */}
                <Grid container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent:"space-between"}}>
                <Grid item lg={10} md={10} sm={10} xs={10}>
                    <Typography level="h5" sx={{textAlign:"center"}}>Send Us The Email</Typography>
                </Grid>
                <Grid item lg={2} md={2} sm={2} xs={2} sx={{textAlign:"right"}}>
                    <CloseIcon  onClick={closeEmailChatPopup}/>
                </Grid>
                </Grid>
            </DialogTitle>
            <DialogActions >
            <Grid container item lg={12} md={12} sm={12} xs={12} >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                        id="outlined-start-adornment"
                        type="text"
                        label="From Email Address"
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin="dense"
                        autoComplete="email"
                        value={values.email}
                        onChange={handleChange('email')}
                        onBlur={handleBlur('email')} 
                        InputLabelProps={{
                            shrink: Boolean(values.email), 
                        }}
                        />
                        {touched.email && errors.email ? <div className="error">{errors.email}</div> : null}
                    </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                    id="outlined-start-adornment"
                    type="text"
                    label="Subject"
                    fullWidth
                    variant="outlined"
                    size="small"
                    margin='dense'
                    autoComplete='subject'
                    value={values.subject}
                    onChange={handleChange('subject')}
                    onBlur={handleBlur('subject')}
                    InputLabelProps={{
                        shrink: Boolean(values.subject)
                    }}
                    /> 
                    {touched.subject && errors.subject ? <div className='error'>{errors.subject}</div> : null}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                    <TextareaAutosize
                        placeholder="Message"
                        type="text"
                        size="small"
                        fullWidth
                        name='description'
                        autoComplete='description'
                        id='description'
                        onChange={handleChange('description')}
                        onBlur={handleBlur('description')}
                        value={values.description}
                        maxRows={7}
                        minRows={4}
                        
                        style={{
                        width: '100%', // Ensures full width
                        // padding: '8px', // Optional for better spacing
                        boxSizing: 'border-box', // Ensures padding doesn't affect width
                    }}
                    />
                    {touched.description && errors.description ? <div className='error'>{errors.description}</div> : null}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent: "center", display: "flex"}}>
                <Button variant="contained" sx={{ minWidth: 200 }} color="success" 
                    onClick={handleSubmit}
                    >
                    Send
                </Button>
                </Grid>
            </Grid>
            </DialogActions>
            </Dialog>
        )}
        </Formik>

        {/* Iframe Dialog Start */}
        <Dialog open={openIframe}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    handleCloseDialog();
                }
            }}
            fullWidth={fullWidth}
            maxWidth={maxWidth}>
            <DialogTitle sx={{ bgcolor: "#F6FAFF" }}>
                <Grid container item xs sx={{ justifyContent: "space-between" }}>
                    <Grid item xs>
                        <Typography level="h4" color="primary">Learn More About Us</Typography>
                    </Grid>
                    <Grid item xs sx={{ textAlign: "right" }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDialog}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent : "center" }}>
                    <iframe
                        width="560"
                        height="315"
                        src={creditSnapshotObj && creditSnapshotObj.funding_shot ? creditSnapshotObj.funding_shot.step3_link : ''}
                        title="Video Player"
                        // frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </Grid>
            </DialogContent>
            {/* </DialogActions> */}
        </Dialog>
        {/* Iframe Dialog End */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    );
}





export default ScoreReport;